export default __webpack_public_path__ + "static/assets/00fcb0dc8def104031efa7615cfa6c53.png";